import React, { useEffect, useRef, useState } from "react";
import { ErrorToast, SuccessToast } from "../../../../Utils/SweetAlert";
import { useMutateUpdateFreeChatLimit, useMutateUpdateVersion } from "../hooks/useApihook";
import { Field, Form, Formik } from "formik";

import InputWithLabel from "../../../../Components/InputWithLabel";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { GetAppVersion, GetFreeChatLimit } from "../../../../Api/setting";
import SaveButton from "../../../../Components/SaveButton";
import { FreeChatLimitIntialValues, FreeChatLimitValidationSchema } from "../../constant";

const FreeUserChatLimit = () => {
  const navigate = useNavigate();
  const freeChatLimitApi = useMutateUpdateFreeChatLimit();
  const formRef = useRef();
  const [isLoading, setIsLoading] = useState(false);
  const [initialValue, setInitialValue] = useState(null);

  const { data: freeChatLimitData } = useQuery({
    queryKey: ["get-free-chat-limit"],
    queryFn: () => GetFreeChatLimit(),
    throwOnError: true,
    onError: (error) => {
      ErrorToast(
        error?.response?.data?.message || error?.message || "Server Error."
      );
    },
  });

  useEffect(() => {
    if (freeChatLimitData) {
      const limitValue = freeChatLimitData?.data?.limit || 1;
      setInitialValue(limitValue);
      if (formRef?.current?.values) {
        formRef?.current?.setValues({
          freeChatLimit: limitValue,
        });
      }
    }
  }, [freeChatLimitData]);

  const updateFreeChatLimit = (values) => {
    const reqData = {
      limit: values?.freeChatLimit,
    };

    setIsLoading(true);
    freeChatLimitApi.mutate(reqData, {
      onSuccess: (response) => {
        SuccessToast(response || "Open AI chat message limit update successfully.");
        navigate("/admin/setting");
        setIsLoading(false);
      },
      onError: (error) => {
        ErrorToast(error?.response?.data?.message || "Server Error.");
        setIsLoading(false);
      },
    });
  };

  return (
    <div className="setting-border overflow-visible">
      <div className="">
        <div className="row">
          <div className="col-md-12">
            {/* Notification Message */}
            <div className="alert alert-warning" role="alert" style={{ backgroundColor: '#fff3cd', borderColor: '#ffeaa7', color: '#856404' }}>
              Free users will be limited to the number of messages specified below.
            </div>
            <section className="">
              <Formik
                initialValues={FreeChatLimitIntialValues}
                validationSchema={FreeChatLimitValidationSchema}
                validateOnChange
                innerRef={formRef}
                onSubmit={updateFreeChatLimit}
              >
                {(formik) => {
                  const { isSubmitting, values } = formik;
                  const hasChanged = initialValue !== null && values.freeChatLimit !== initialValue;

                  return (
                    <Form>
                      <div className="row">
                        <div className="col-md-6">
                          <Field
                            Label="Free Chat Limit"
                            type="number"
                            name="freeChatLimit"
                            placeholder="Enter chat limit (1 to unlimited)"
                            min="1"
                            component={InputWithLabel}
                          />
                        </div>
                      </div>
                      <SaveButton loading={isLoading} />
                    </Form>
                  );
                }}
              </Formik>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FreeUserChatLimit;
